import { render, staticRenderFns } from "./NewVersionMessage.vue?vue&type=template&id=32add5c3&"
import script from "./NewVersionMessage.vue?vue&type=script&lang=js&"
export * from "./NewVersionMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports